import script from "./flash.vue?vue&type=script&setup=true&lang=js"
export * from "./flash.vue?vue&type=script&setup=true&lang=js"

import "./flash.vue?vue&type=style&index=0&id=483e76f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-483e76f7"]])

export default __exports__